// 日本の歴史スポット。東京と各地の都市から、政治・信仰・交易・庭園・近代化をたどる。
// レコードの各フィールドの意味は src/historicSitesData.js の冒頭コメントを参照。

export const JAPAN_SITES = [
  {
    id: 'horyuji',
    name: '法隆寺',
    nameEn: 'Hōryū-ji',
    lat: 34.6147, lng: 135.7348, elevationM: 50,
    region: 'japan', era: 'ancient',
    country: '日本（奈良県斑鳩町）',
    civilization: '飛鳥時代・推古朝',
    yearLabel: '607年創建と伝わる / 7世紀後半に再建',
    whcYear: 1993,
    whcNote: '「法隆寺地域の仏教建造物」',
    emoji: '🛕',
    facts: [
      { label: '構造', value: '現存する世界最古級の木造建築群' },
    ],
    summary:
      '推古天皇と厩戸王（聖徳太子）の発願により607年に創建されたと伝わる寺院。現存する金堂・五重塔・中門・回廊は7世紀後半の再建とみられ、木造建築としては世界でも最古の部類に入る。柱の中ほどがふくらむエンタシスや雲斗雲肘木といった意匠には、中国の南北朝から朝鮮半島を経て伝わった様式が色濃く残り、6世紀の仏教公伝とともに大陸の技術と思想が日本へ流れ込んだことを今に伝える。1993年、姫路城とともに日本で最初の世界文化遺産に登録された。',
    quiz: {
      statement: '法隆寺の金堂と五重塔は、創建当時（607年）の建物がそのまま現存している。',
      answer: false,
      explain: '『日本書紀』は670年の焼失を伝えており、現存する西院伽藍は7世紀後半の再建とみられます。それでも世界最古級の木造建築であることに変わりはありません。',
    },
  },
  {
    id: 'todaiji',
    name: '東大寺 大仏殿',
    nameEn: 'Tōdai-ji',
    lat: 34.6889, lng: 135.8398, elevationM: 100,
    region: 'japan', era: 'ancient',
    country: '日本（奈良県奈良市）',
    civilization: '奈良時代・聖武天皇',
    yearLabel: '752年 大仏開眼供養 / 現在の大仏殿は1709年再建',
    whcYear: 1998,
    whcNote: '「古都奈良の文化財」の一部',
    emoji: '🛕',
    facts: [
      { label: '大仏', value: '盧舎那仏坐像・高さ約15m' },
    ],
    summary:
      '疫病と飢饉、政変に揺れた8世紀の日本で、聖武天皇が「鎮護国家」を掲げて建立した官立寺院。743年の大仏造立の詔を受けて盧舎那仏の鋳造が始まり、752年にはインド僧菩提僊那を導師として開眼供養が営まれた。全国に置かれた国分寺・国分尼寺の総本山にあたり、律令国家が仏教を統治の柱に据えたことを示している。現在の大仏殿は1709年の再建で、財政難から間口は創建時の約3分の2に縮んだが、それでも世界有数の規模を誇る木造建築である。',
    quiz: {
      statement: '現在の東大寺大仏殿は、奈良時代に建てられた当時のままの大きさである。',
      answer: false,
      explain: '大仏殿は源平の争乱と戦国期の2度焼失し、現在の建物は1709年（江戸時代）の再建です。財政難のため間口は創建時の約3分の2に縮小されました。',
    },
  },
  {
    id: 'daisenryo-kofun',
    name: '大仙陵古墳（仁徳天皇陵）',
    nameEn: 'Daisenryō Kofun',
    lat: 34.5645, lng: 135.4877, elevationM: 10,
    region: 'japan', era: 'ancient',
    country: '日本（大阪府堺市）',
    civilization: '古墳時代・ヤマト王権',
    yearLabel: '5世紀中頃',
    whcYear: 2019,
    whcNote: '「百舌鳥・古市古墳群」の一部',
    emoji: '⛰',
    facts: [
      { label: '規模', value: '墳丘長 約486m・三重の濠' },
    ],
    summary:
      '墳丘長486mにおよぶ日本最大の前方後円墳で、三重の濠に囲まれる。クフ王のピラミッド、秦の始皇帝陵と並んで「世界三大墳墓」に数えられることがある。5世紀中頃の築造とみられ、東アジアの他地域には見られない鍵穴形の墳形は、ヤマト王権が各地の首長と結んだ政治秩序の象徴と考えられている。ちょうど『宋書』倭国伝に見える「倭の五王」が中国南朝へたびたび遣使し、朝鮮半島南部をめぐる立場を認めさせようとした時代にあたる。2019年に世界文化遺産へ登録された。',
    quiz: {
      statement: '前方後円墳は日本列島を中心に分布する独自の墳形で、中国の皇帝陵を写したものではない。',
      answer: true,
      explain: '前方後円墳は日本列島（および朝鮮半島南西部の一部）に見られる独自の墳形です。中国の陵墓は方形や円形の墳丘が基本で、鍵穴形は見られません。',
    },
  },
  {
    id: 'kinkakuji',
    name: '金閣寺（鹿苑寺）',
    nameEn: 'Kinkaku-ji',
    lat: 35.0394, lng: 135.7292, elevationM: 80,
    region: 'japan', era: 'medieval',
    country: '日本（京都府京都市）',
    civilization: '室町時代・北山文化',
    yearLabel: '1397年造営 / 1955年再建',
    whcYear: 1994,
    whcNote: '「古都京都の文化財」の一部',
    emoji: '🏯',
    summary:
      '室町幕府3代将軍足利義満が1397年に営んだ北山山荘が前身で、その死後に禅寺（鹿苑寺）となった。舎利殿「金閣」は、初層が寝殿造風、二層が武家造風、三層が禅宗様仏殿という三つの様式を積み重ねたもので、公家・武家・禅林の文化が融け合った北山文化を象徴する。義満は1401年に明へ使者を送り「日本国王」として冊封を受け、勘合貿易を開いた。その富がこの金箔の楼閣を支えている。1950年に放火で焼失し、1955年に再建された。',
    quiz: {
      statement: '金閣を建てた足利義満は、明の皇帝から「日本国王」に封じられ、勘合貿易を行った。',
      answer: true,
      explain: '義満は1401年に明へ使者を送り、翌年「日本国王」として冊封されました。倭寇と区別するための勘合を用いた朝貢貿易は、幕府の大きな財源となりました。',
    },
  },
  {
    id: 'himeji-castle',
    name: '姫路城',
    nameEn: 'Himeji Castle',
    lat: 34.8394, lng: 134.6939, elevationM: 40,
    region: 'japan', era: 'earlymodern',
    country: '日本（兵庫県姫路市）',
    civilization: '安土桃山〜江戸時代初期',
    yearLabel: '1609年 現在の連立式天守が完成',
    whcYear: 1993,
    emoji: '🏯',
    facts: [
      { label: '別名', value: '白鷺城' },
      { label: '現況', value: '現存12天守のひとつ' },
    ],
    summary:
      '関ヶ原の戦いののち播磨に入った池田輝政が、1601年から約8年をかけて大改修し、1609年に現在の連立式天守を完成させた。白漆喰総塗籠の外観から「白鷺城」と呼ばれる。西国の外様大名を抑える幕府の要として築かれ、迷路のように折れ曲がる螺旋状の縄張り、狭間や石落としなど、戦国末期に到達した築城技術の集大成となっている。戦災も大地震も免れ、創建時の天守がほぼそのまま残る数少ない城で、1993年に日本初の世界文化遺産となった。',
    quiz: {
      statement: '姫路城の天守は太平洋戦争の空襲で焼失し、鉄筋コンクリートで再建されたものである。',
      answer: false,
      explain: '姫路も空襲を受けましたが天守は焼け残り、現存12天守のひとつです。名古屋城や広島城の天守が戦災で失われて再建されたのとは異なります。',
    },
  },
  {
    id: 'shurijo',
    name: '首里城',
    nameEn: 'Shuri Castle',
    lat: 26.2170, lng: 127.7194, elevationM: 130,
    region: 'japan', era: 'earlymodern',
    country: '日本（沖縄県那覇市）',
    civilization: '琉球王国',
    yearLabel: '1429年 琉球王国成立 / 1879年 琉球処分',
    whcYear: 2000,
    whcNote: '「琉球王国のグスク及び関連遺産群」の一部',
    emoji: '🏯',
    facts: [
      { label: '現況', value: '2019年の火災で正殿が焼失し再建中' },
    ],
    summary:
      '1429年に尚巴志が三山を統一して成立した琉球王国の王城。明・清への朝貢と、日本・朝鮮・東南アジアを結ぶ中継貿易で栄え、「万国津梁（世界を結ぶ架け橋）」を掲げた海洋王国の中枢だった。正殿は中国建築の朱塗りや龍柱と、日本建築の木造軸組が融合した独自の様式をもつ。1609年の薩摩侵攻後も中国への朝貢は続き、1879年の琉球処分で王国は幕を閉じた。1945年の沖縄戦で焼失、1992年に復元されたが2019年の火災で再び正殿を失い、現在再建が進む。',
    quiz: {
      statement: '琉球王国は、明・清に朝貢しながら江戸時代には薩摩藩の支配も受けるという両属の状態にあった。',
      answer: true,
      explain: '1609年の薩摩侵攻の後も中国への朝貢は続けられ、幕藩体制と冊封体制の両方に属する形が、明治の琉球処分まで続きました。',
    },
  },
  {
    id: 'atomic-bomb-dome',
    name: '原爆ドーム',
    nameEn: 'Atomic Bomb Dome',
    lat: 34.3955, lng: 132.4536, elevationM: 5,
    region: 'japan', era: 'modern',
    country: '日本（広島県広島市）',
    civilization: '第二次世界大戦',
    yearLabel: '1915年建設 / 1945年8月6日 被爆',
    whcYear: 1996,
    emoji: '🕊',
    facts: [
      { label: '爆心地から', value: '約160m' },
    ],
    summary:
      'チェコの建築家ヤン・レツルの設計により、1915年に広島県物産陳列館として竣工したネオバロック風の建物。1945年8月6日午前8時15分、上空約600mで炸裂した原子爆弾の爆心地からわずか約160mにありながら、爆風をほぼ真上から受けたため、鉄骨のドームと外壁だけが崩れずに残った。核兵器が実戦で使われた事実と、その日に失われた十数万の命を伝える「負の世界遺産」として1996年に登録され、二度と繰り返さないという誓いの象徴となっている。',
    // 追悼施設: クイズも「NEW!」バッジも出さない。
    solemn: true,
    quiz: null,
  },
  {
    // 出典: https://www.kunaicho.go.jp/wp-content/uploads/2026/03/illustrationmap-j.pdf
    sources: ['https://www.kunaicho.go.jp/wp-content/uploads/2026/03/illustrationmap-j.pdf'],
    id: 'edo-castle',
    name: '江戸城跡（皇居東御苑）',
    nameEn: 'Edo Castle Ruins',
    lat: 35.6885, lng: 139.7543, elevationM: 25,
    region: 'japan', era: 'earlymodern',
    country: '日本（東京都千代田区）', civilization: '江戸時代・徳川幕府',
    yearLabel: '1603年 江戸幕府成立 / 1657年 天守焼失',
    whcYear: null, emoji: '🏯',
    summary:
      '徳川家康が江戸に幕府を開いた1603年以降、江戸城は全国の大名を統治する政治の中心となった。堀や石垣の工事には各地の大名が動員され、城の周囲には武家屋敷や町人地が広がった。天守は1657年の明暦の大火で焼け、その後は天守台が築き直されたものの、天守そのものは再建されなかった。現在の皇居東御苑には、かつての本丸や二の丸の一部、石垣や門が残る。上空から堀の曲線と周辺の街路を見比べると、城を核として発達した江戸の構造が、近代都市東京にも受け継がれていることが分かる。建物が失われた場所でも、地形や区画は歴史を読み解く手がかりになる。',
    quiz: {
      statement: '江戸城の天守は、1657年に焼けた後、江戸時代のうちに再建された。',
      answer: false,
      explain: '天守台は築き直されましたが、天守は再建されませんでした。東御苑に残る大きな石の台から、失われた建物の規模を想像できます。',
    },
  },
  {
    // 出典: https://www.senso-ji.jp/about/
    sources: ['https://www.senso-ji.jp/about/'],
    id: 'sensoji',
    name: '浅草寺', nameEn: 'Sensō-ji',
    lat: 35.7148, lng: 139.7967, elevationM: 5,
    region: 'japan', era: 'ancient',
    country: '日本（東京都台東区）', civilization: '飛鳥時代の伝承・江戸の町人文化',
    yearLabel: '628年 創建と伝わる / 1958年 本堂再建',
    whcYear: null, emoji: '🛕',
    summary:
      '浅草寺は、628年に隅田川で漁をしていた兄弟が観音像を見つけ、それをまつったことに始まると寺伝に記される。これは寺に伝わる由来であり、現在の建物がその時代から残っているという意味ではない。江戸時代には観音信仰を集める寺としてにぎわい、参拝の道沿いには商いの場が発達した。雷門から仲見世を通って本堂へ続く配置は、信仰と買い物や行楽が結び付いた都市生活を伝える。本堂は第二次世界大戦で焼失し、1958年に再建された。隅田川と参道の位置を空から確かめると、川の交通や門前の商業が寺を中心に集まった町の姿を読み取れる。東京には近代以前から続く生活の歴史も重なっている。',
    quiz: {
      statement: '浅草寺の仲見世は、参拝者が集まる寺の門前に商業が発達した例である。',
      answer: true,
      explain: '寺への参拝は信仰だけでなく買い物や行楽にも結び付きました。参道と店の並びから、門前町の成り立ちを考えられます。',
    },
  },
  {
    // 出典: https://www.meijijingu.or.jp/about/
    sources: ['https://www.meijijingu.or.jp/about/'],
    id: 'meiji-jingu',
    name: '明治神宮', nameEn: 'Meiji Jingū',
    lat: 35.6764, lng: 139.6993, elevationM: 35,
    region: 'japan', era: 'modern',
    country: '日本（東京都渋谷区）', civilization: '大正時代・近代の都市と森林',
    yearLabel: '1920年 創建',
    whcYear: null, emoji: '⛩',
    summary:
      '明治天皇と昭憲皇太后をまつるため、1920年に代々木に創建された神社。名前には「明治」とあるが、創建は二人の没後の大正時代である。周囲の広い森も、太古からそのまま残る原生林ではない。全国から寄せられた約10万本の木を植え、長い年月のうちに育つ姿を考えてつくられた人工林である。都市化が進む東京の中に、参道と社殿を包み込む緑の空間が設計された。上空から見ると、新宿や原宿の建物が密集する街と森との境界がよく分かる。神社の歴史に加え、人々が将来の自然環境を計画し、世代を越えて育てるという発想を学べる場所でもある。都市の緑にも人の営みの歴史が刻まれている。',
    quiz: {
      statement: '明治神宮の森は、創建に合わせて人々が木を植えて育てた人工林である。',
      answer: true,
      explain: '創建時に全国から寄せられた約10万本の木を植えました。将来の森林の姿を考えて造成された森です。',
    },
  },
  {
    // 出典: https://www.zojoji.or.jp/info/history.html
    sources: ['https://www.zojoji.or.jp/info/history.html'],
    id: 'zojoji',
    name: '増上寺', nameEn: 'Zōjō-ji',
    lat: 35.6574, lng: 139.7483, elevationM: 10,
    region: 'japan', era: 'earlymodern',
    country: '日本（東京都港区）', civilization: '江戸時代・徳川家と浄土宗',
    yearLabel: '1393年 開山 / 1598年 現在地へ移転',
    whcYear: null, emoji: '🛕',
    summary:
      '増上寺は1393年に開かれた浄土宗の寺院で、徳川家康が関東に入ると徳川家の菩提寺となり、1598年に現在の芝へ移った。菩提寺とは、一族の死者を弔い、供養を続ける寺のことである。江戸時代には六人の将軍の墓所が設けられ、僧侶が学ぶ場としても大きな役割を担った。将軍家の保護を受けた大寺院は、信仰の拠点であると同時に幕府と宗教の関係を示す存在だった。現在、境内の背後には東京タワーが立ち、寺院と近代の都市景観を一度に見渡せる。江戸城から南へ飛んで位置を確かめれば、江戸の政治の中心と有力寺院がどのように配置されていたかを考えることができる。',
    quiz: {
      statement: '増上寺は、東京タワーの建設に合わせて初めてつくられた寺院である。',
      answer: false,
      explain: '増上寺の開山は1393年で、1598年に芝へ移りました。東京タワーより何世紀も前から続く寺院です。',
    },
  },
  {
    // 出典: https://www.tokyo-park.or.jp/park/rikugien/index.html
    sources: ['https://www.tokyo-park.or.jp/park/rikugien/index.html'],
    id: 'rikugien',
    name: '六義園', nameEn: 'Rikugien Gardens',
    lat: 35.7331, lng: 139.7462, elevationM: 20,
    region: 'japan', era: 'earlymodern',
    country: '日本（東京都文京区）', civilization: '江戸時代・大名庭園と和歌',
    yearLabel: '1702年 庭園完成',
    whcYear: null, emoji: '🌳',
    summary:
      '五代将軍徳川綱吉に仕えた柳沢吉保が、1695年に与えられた駒込の土地に造り、1702年に完成させた大名庭園。平らな土地に池を掘り、土を盛って山をつくり、歩くにつれて景色が変わる回遊式の庭に仕立てた。和歌に詠まれた名所などを庭の風景に取り入れ、文学の世界を実際の空間で味わえるようにしている。大名の文化は城や武具だけでなく、古典の知識や庭園づくりにも表れた。明治時代には岩崎家の所有となり、のちに東京市へ寄贈された。空から池と築山、周囲の市街地を見比べると、江戸の大名屋敷の一部が現代の都市に残った姿が分かる。自然に見える風景にも設計者の意図がある。',
    quiz: {
      statement: '六義園は、和歌などの文学に登場する風景を庭づくりに取り入れている。',
      answer: true,
      explain: '柳沢吉保は和歌の趣味を庭の景観に反映しました。池や築山は、文学と造園が結び付いた文化の表現でもあります。',
    },
  },
  {
    // 出典: https://www.city.katsushika.lg.jp/history/history/2-3-3-132.html
    sources: ['https://www.city.katsushika.lg.jp/history/history/2-3-3-132.html'],
    id: 'shibamata-taishakuten',
    name: '柴又帝釈天（題経寺）', nameEn: 'Shibamata Taishakuten',
    lat: 35.7581, lng: 139.8689, elevationM: 5,
    region: 'japan', era: 'earlymodern',
    country: '日本（東京都葛飾区）', civilization: '江戸時代・庶民の信仰と門前町',
    yearLabel: '1629年 創建',
    whcYear: null, emoji: '🛕',
    summary:
      '柴又帝釈天として知られる題経寺は、1629年に創建された日蓮宗の寺院。寺の記録では、1779年の本堂修理の際に、行方が分からなくなっていた板本尊が発見されたという。その日が庚申の日だったことから庚申信仰と結び付き、縁日に多くの人が訪れるようになった。庚申は干支を組み合わせた暦で60日ごとに巡る日で、人々の健康や長寿への願いと関わっていた。参詣が盛んになると、寺へ向かう道には飲食や買い物の店が集まり、門前町が育った。江戸川に近い寺と参道を空からたどると、都心の城や大寺院だけでは見えない、江戸の周辺地域に暮らした人々の信仰と行楽のつながりを考えられる。',
    quiz: {
      statement: '柴又帝釈天の縁日と結び付く庚申の日は、毎年一度だけ巡ってくる。',
      answer: false,
      explain: '庚申の日は干支の組合せによって60日ごとに巡ります。寺への参詣と暦の習慣が結び付いていました。',
    },
  },
  {
    // 出典: https://www.city.chofu.lg.jp/100200/p073023.html
    // 出典: https://www.city.chofu.lg.jp/040040/p023098.html
    sources: ['https://www.city.chofu.lg.jp/100200/p073023.html', 'https://www.city.chofu.lg.jp/040040/p023098.html'],
    id: 'jindaiji',
    name: '深大寺', nameEn: 'Jindai-ji',
    lat: 35.6675, lng: 139.5501, elevationM: 50,
    region: 'japan', era: 'ancient',
    country: '日本（東京都調布市）', civilization: '奈良時代・武蔵野の仏教文化',
    yearLabel: '733年 開創と伝わる',
    whcYear: null, emoji: '🛕',
    summary:
      '深大寺は、満功上人が733年に開いたと伝わる武蔵野の寺院。周囲には湧き水があり、寺の名も水に関わる神である深沙大王に由来する。寺宝の銅造釈迦如来倚像は「白鳳仏」と呼ばれ、7世紀後半から末頃につくられたと推定される国宝である。白鳳は仏教美術の時代区分で、仏像の姿や製作技法から当時の文化交流を考える手がかりになる。創建の伝承と仏像の推定年代は別の情報であり、混同しないことも歴史を読むうえで大切である。境内には火災や再建の歴史も重なっている。上空から林や周囲の住宅地を見ると、古代の信仰の場が、東京の郊外へ広がった現代の街の中に受け継がれていることが分かる。',
    quiz: {
      statement: '深大寺の白鳳仏は、寺の創建伝承より前の時代につくられたと推定されている。',
      answer: true,
      explain: '白鳳仏は7世紀後半から末頃の製作と推定され、寺の開創は733年と伝わります。仏像の年代と寺の由来は区別して読みます。',
    },
  },
  {
    // 出典: https://www.osakacastle.net/
    sources: ['https://www.osakacastle.net/'],
    id: 'osaka-castle',
    name: '大阪城', nameEn: 'Osaka Castle',
    lat: 34.6873, lng: 135.5262, elevationM: 25,
    region: 'japan', era: 'earlymodern',
    country: '日本（大阪府大阪市）', civilization: '豊臣政権・徳川幕府',
    yearLabel: '1583年 築城開始 / 1931年 現在の天守復興',
    whcYear: null, emoji: '🏯',
    summary:
      '豊臣秀吉が1583年に石山本願寺の跡で築城を始め、天下統一を進める拠点とした城。水運が集まる大坂の立地は、軍事だけでなく物資や富を集めるうえでも重要だった。1615年の大坂夏の陣で豊臣氏が滅ぶと、徳川幕府はその後に城を大規模に築き直した。このため、現在見える石垣や堀をすべて秀吉の時代のものと考えることはできない。現在の天守も、1931年に市民の寄付によって復興された建物で、博物館として歴史を伝えている。空から何重もの堀と石垣を眺めれば、防御の工夫と城の巨大さを確かめられる。一つの城に豊臣・徳川・近代大阪という異なる時代が重なる点に注目したい。',
    quiz: {
      statement: '現在の大阪城天守は、豊臣秀吉が建てた木造天守がそのまま残ったものである。',
      answer: false,
      explain: '現在の天守は1931年に市民の寄付で復興されました。石垣や堀にも徳川幕府による再築の歴史が重なっています。',
    },
  },
  {
    // 出典: https://www.nagoyajo.city.nagoya.jp/learn/development/kiyosugoshi/
    sources: ['https://www.nagoyajo.city.nagoya.jp/learn/development/kiyosugoshi/'],
    id: 'nagoya-castle',
    name: '名古屋城', nameEn: 'Nagoya Castle',
    lat: 35.1856, lng: 136.8990, elevationM: 15,
    region: 'japan', era: 'earlymodern',
    country: '日本（愛知県名古屋市）', civilization: '江戸時代・尾張徳川家',
    yearLabel: '1610年 築城開始 / 1612年 天守完成',
    whcYear: null, emoji: '🏯',
    summary:
      '徳川家康の命で1610年に築城が始まり、1612年に天守が完成した城。尾張徳川家の拠点となり、東海道と美濃方面を結ぶ地域を押さえた。築城とともに清須から武士や町人、寺社などが移る「清須越」が進み、新しい城下町が形づくられた。城は戦いの備えであると同時に、人や仕事を集めて都市そのものをつくる役割も果たしたのである。天守や本丸御殿は1945年の空襲で失われ、戦後には復元や再建が行われた。城の南に広がる街路と堀を上空から見比べると、計画的に整えられた城下町の成り立ちを考えられる。江戸城や大阪城と比べ、同じ徳川の時代でも城が担った地域の役割の違いに注目できる。',
    quiz: {
      statement: '名古屋城の築城に伴い、清須から人々や寺社が移る「清須越」が進んだ。',
      answer: true,
      explain: '清須越では城だけでなく武士や町人の住居、寺社なども移されました。名古屋の城下町形成と結び付いた出来事です。',
    },
  },
  {
    // 出典: https://www.hokkaidojingu.or.jp/history.html
    sources: ['https://www.hokkaidojingu.or.jp/history.html'],
    id: 'hokkaido-jingu',
    name: '北海道神宮', nameEn: 'Hokkaidō Jingū',
    lat: 43.0543, lng: 141.3078, elevationM: 50,
    region: 'japan', era: 'modern',
    country: '日本（北海道札幌市）', civilization: '明治時代・札幌の都市形成',
    yearLabel: '1871年 現在地に社殿造営',
    whcYear: null, emoji: '⛩',
    summary:
      '明治政府が北海道の開拓を進めるなか、1869年に開拓の守護神をまつる方針が定められ、1871年に現在の円山の地に社殿が造られた。当初は札幌神社と呼ばれ、1964年に明治天皇を合わせてまつった際に北海道神宮へ改称された。札幌の街づくりと結び付いた、近代に生まれた神社である。「開拓」という言葉は政府や移住者の視点を含むため、それ以前から北海道に暮らしていたアイヌの人々の歴史とも合わせて考えることが大切だ。上空から円山の森と碁盤の目のような札幌の市街地を見比べれば、地形を利用した信仰の場と計画都市の関係が見えてくる。古い意匠の建築でも、成立した時代はさまざまである。',
    quiz: {
      statement: '北海道神宮は、奈良時代に建てられた神社をそのまま受け継いでいる。',
      answer: false,
      explain: '現在地の社殿造営は1871年で、明治時代の札幌の都市形成と関係します。建築の見た目だけでは創建年代は判断できません。',
    },
  },
  {
    // 出典: https://www.city.sendai.jp/museum/kidscorner/kids-08/kidscorner-03/index.html
    sources: ['https://www.city.sendai.jp/museum/kidscorner/kids-08/kidscorner-03/index.html'],
    id: 'sendai-castle',
    name: '仙台城跡（青葉城）', nameEn: 'Sendai Castle Ruins',
    lat: 38.2524, lng: 140.8561, elevationM: 115,
    region: 'japan', era: 'earlymodern',
    country: '日本（宮城県仙台市）', civilization: '江戸時代・仙台藩と伊達政宗',
    yearLabel: '1601年 築城開始',
    whcYear: null, emoji: '🏯',
    summary:
      '伊達政宗が1601年に工事を始めた仙台藩の城。政宗は岩出山から拠点を移し、城と城下町を一体として整備した。広い仙台平野や海に近い交通上の位置に加え、青葉山の高台と広瀬川の崖は防御にも役立った。城づくりには武士だけでなく、移住を命じられた町人や周辺の農民も関わった。現在は多くの建物が失われているが、石垣や本丸跡の位置から城の規模を想像できる。上空から川の曲がり方と丘の高さ、市街地の広がりを見比べると、この場所が選ばれた理由を考えられる。歴史上の人物の行動を地形や交通の条件と結び付けて読むと、築城の年号だけを覚えるより都市の成り立ちを具体的に理解できる。',
    quiz: {
      statement: '仙台城の立地には、広瀬川や青葉山の地形を防御に利用する利点があった。',
      answer: true,
      explain: '高台や川沿いの崖は自然の防御になります。城と平野、川、市街地の位置を見比べると築城の意図を考えられます。',
    },
  },
  {
    // 出典: https://bunkazai.city.fukuoka.lg.jp/courses/detail/22
    sources: ['https://bunkazai.city.fukuoka.lg.jp/courses/detail/22'],
    id: 'fukuoka-castle',
    name: '福岡城跡', nameEn: 'Fukuoka Castle Ruins',
    lat: 33.5844, lng: 130.3839, elevationM: 25,
    region: 'japan', era: 'earlymodern',
    country: '日本（福岡県福岡市）', civilization: '江戸時代・福岡藩と黒田氏',
    yearLabel: '1601年 築城開始',
    whcYear: null, emoji: '🏯',
    summary:
      '関ヶ原の戦いの後に筑前へ入った黒田長政が、1601年から約7年をかけて築いた城。黒田家ゆかりの備前国福岡にちなむ名が、城と城下町に付けられた。現在の福岡市の名は、この城下町の歴史と関わっている。一方、近くの博多は以前から交易や商業で知られた町であり、武士の町と商人の町が並んで発展した。城内には石垣や一部の櫓が残り、さらに古代の外交施設である鴻臚館の遺跡も発見された。同じ土地に異なる時代の交流と政治の拠点が重なる点が興味深い。上空から城跡と博多方面を見渡すと、現代の一つの都市にも複数の成り立ちがあることを考えられる。堀や区画にもその歴史が残る。',
    quiz: {
      statement: '福岡という城下町の名前は、黒田家にゆかりのある備前国の地名に由来する。',
      answer: true,
      explain: '黒田氏は備前国福岡にちなみ城を福岡城と名付けました。商業都市として発展した博多とは異なる成り立ちがあります。',
    },
  },
  {
    // 出典: https://www.yokohama-akarenga.jp/about/
    sources: ['https://www.yokohama-akarenga.jp/about/'],
    id: 'yokohama-red-brick',
    name: '横浜赤レンガ倉庫', nameEn: 'Yokohama Red Brick Warehouse',
    lat: 35.4526, lng: 139.6429, elevationM: 3,
    region: 'japan', era: 'modern',
    country: '日本（神奈川県横浜市）', civilization: '明治・大正時代・近代貿易',
    yearLabel: '1911年 2号館竣工 / 1913年 1号館竣工',
    whcYear: null, emoji: '🏭',
    summary:
      '横浜港の新港ふ頭に国の保税倉庫として建てられ、1911年に2号館、1913年に1号館が完成した。保税倉庫とは、輸入品などを関税の手続きとの関係で管理しながら置く施設で、国際貿易を支える裏方だった。荷物用エレベーターや防火設備などを備え、港の近代化を示す建築でもある。関東大震災による被災や修復を経て、倉庫としての役目を終えた後は保存と活用が進められ、2002年に文化・商業施設として再出発した。現在のにぎわいだけでなく、船から陸へ物資を移す場所だったことを想像してみたい。空から岸壁と倉庫の位置を眺めると、建物の用途と港の地理が密接につながっていたことが分かる。',
    quiz: {
      statement: '横浜赤レンガ倉庫は、最初から観光客向けの商業施設として建設された。',
      answer: false,
      explain: 'もとは国際貿易の物資を保管する保税倉庫でした。歴史的建物を保存し、新しい用途で使う取り組みの例です。',
    },
  },
  {
    // 出典: https://nagasakidejima.jp/history/
    sources: ['https://nagasakidejima.jp/history/'],
    id: 'dejima',
    name: '出島', nameEn: 'Dejima',
    lat: 32.7435, lng: 129.8735, elevationM: 3,
    region: 'japan', era: 'earlymodern',
    country: '日本（長崎県長崎市）', civilization: '江戸時代・海外交易と蘭学',
    yearLabel: '1636年 完成 / 1641年 オランダ商館移転',
    whcYear: null, emoji: '⚓',
    summary:
      '出島は1636年、長崎の港に築かれた扇形の人工島で、初めはポルトガル人を住まわせるために造られた。ポルトガル船の来航が禁じられた後、1641年に平戸のオランダ商館が移された。江戸幕府は人や船の出入りを管理しながら交易を続け、通詞などを介して海外の情報や学問も伝わった。いわゆる鎖国の時代も、日本と外国の交流が完全になくなったわけではない。中国との貿易や朝鮮・琉球などとの窓口もあり、出島はその一つだった。周囲の埋立てによって現在は島に見えにくいが、復元された区画からかつての形をたどれる。空から港との距離を見れば、歴史とともに海岸線まで変わったことを考えられる。',
    quiz: {
      statement: '江戸時代の出島では、海外との接触を管理しながらオランダとの交易が続いた。',
      answer: true,
      explain: '幕府は出入りを制限しつつ貿易を認めていました。「鎖国」は外国との交流が完全に途絶えたという意味ではありません。',
    },
  },
  {
    // 出典: https://castle.kumamoto-guide.jp/history/
    sources: ['https://castle.kumamoto-guide.jp/history/'],
    id: 'kumamoto-castle',
    name: '熊本城', nameEn: 'Kumamoto Castle',
    lat: 32.8062, lng: 130.7059, elevationM: 50,
    region: 'japan', era: 'earlymodern',
    country: '日本（熊本県熊本市）', civilization: '江戸時代・加藤氏と細川氏',
    yearLabel: '1607年 築城完了とされる / 1877年 西南戦争',
    whcYear: null, emoji: '🏯',
    summary:
      '加藤清正が築いた城で、1607年に築城が完了したとされる。その後は細川氏の居城となり、熊本の城下町を見守った。上に行くほど反りが強くなる高い石垣は、防御と築城技術を考える手がかりになる。明治時代の1877年には西南戦争の舞台となり、政府軍が城に立てこもった。天守などはこの戦争の際に焼失し、現在の天守は1960年に再建されたものだ。さらに2016年の熊本地震でも石垣や建物が大きく被災した。城の歴史は武将や戦いだけでなく、災害と修復、文化財を次の世代へ伝える営みの歴史でもある。上空から曲輪や堀の配置を見渡すと、現代の街の中に残る城の広さと、守るべき遺構のつながりが分かる。',
    quiz: {
      statement: '熊本城は、明治時代の西南戦争の舞台にもなった。',
      answer: true,
      explain: '1877年の西南戦争で政府軍が籠城しました。江戸時代につくられた城が、近代の戦争にも関わった例です。',
    },
  },
  {
    // 出典: https://shiro-niwa.pref.ishikawa.lg.jp/kenrokuen-garden/
    sources: ['https://shiro-niwa.pref.ishikawa.lg.jp/kenrokuen-garden/'],
    id: 'kenrokuen',
    name: '兼六園', nameEn: 'Kenrokuen Garden',
    lat: 36.5621, lng: 136.6626, elevationM: 50,
    region: 'japan', era: 'earlymodern',
    country: '日本（石川県金沢市）', civilization: '江戸時代・加賀藩の庭園文化',
    yearLabel: '江戸時代 歴代加賀藩主が造営',
    whcYear: null, emoji: '🌳',
    summary:
      '金沢城に隣接し、江戸時代に歴代の加賀藩主が長い時間をかけて整えた大名庭園。一人の設計者が一度につくり上げたのではなく、池や築山、茶屋などが加えられながら景観が形づくられた。池の周囲を歩いて変化する眺めを楽しむ回遊式の庭で、城を中心とする政治の場の近くに、文化や接客の空間が置かれていた。庭園には植物だけでなく、水を引き、地形を加工し、眺めを組み合わせる技術も必要だった。上空から金沢城と庭園の位置関係を見れば、軍事的な城と風景を楽しむ庭が一体の地域を構成していると分かる。東京の六義園と比べると、大名の力や教養が建物以外のかたちでも表現されたことを学べる。',
    quiz: {
      statement: '兼六園は、江戸時代の複数の藩主による造営を経て形づくられた庭園である。',
      answer: true,
      explain: '歴代の加賀藩主が時間をかけて整えました。完成年を一つ覚えるだけでは捉えきれない、積み重ねのある文化財です。',
    },
  },
  {
    // 出典: https://www.kiyomizudera.or.jp/history.php
    // 出典: https://whc.unesco.org/en/list/688/
    sources: ['https://www.kiyomizudera.or.jp/history.php', 'https://whc.unesco.org/en/list/688/'],
    id: 'kiyomizudera',
    name: '清水寺', nameEn: 'Kiyomizu-dera',
    lat: 34.9949, lng: 135.7850, elevationM: 180,
    region: 'japan', era: 'ancient',
    country: '日本（京都府京都市）', civilization: '奈良時代の創建伝承・観音信仰',
    yearLabel: '778年 開創と伝わる / 1633年 本堂再建',
    whcYear: 1994, whcNote: '「古都京都の文化財」の一部', emoji: '🛕',
    summary:
      '清水寺は778年に開かれたと伝わり、音羽の滝と観音信仰に結び付いて発展した寺院。創建の伝承は平安京への遷都より前にさかのぼる。一方、現在の本堂は1633年の再建で、寺の起源と目に見える建物の年代は同じではない。「清水の舞台」として知られる張り出した床は、斜面から組み上げた木の柱によって支えられる。山の地形を取り込んだ建築は、平地の寺とは異なる眺めを生み出した。参道の坂道には店や町並みが広がり、参詣と都市の暮らしを結んでいる。空から東山の斜面と京都盆地を見比べると、寺が街の東の縁に立つ意味が分かる。金閣寺と合わせ、同じ京都でも時代や立地によって文化の表現が異なることを学べる。',
    quiz: {
      statement: '清水寺の現在の本堂は、778年の開創当時の建物がそのまま残ったものである。',
      answer: false,
      explain: '現在の本堂は1633年に再建されました。寺が始まった時期と、現存する建物が造られた時期は分けて考えます。',
    },
  },
  {
    // 出典: https://www.mlit.go.jp/kankocho/content/001473846.pdf
    // 出典: https://whc.unesco.org/en/list/913/
    sources: ['https://www.mlit.go.jp/kankocho/content/001473846.pdf', 'https://whc.unesco.org/en/list/913/'],
    id: 'nikko-toshogu',
    name: '日光東照宮', nameEn: 'Nikkō Tōshō-gū',
    lat: 36.7574, lng: 139.5989, elevationM: 640,
    region: 'japan', era: 'earlymodern',
    country: '日本（栃木県日光市）', civilization: '江戸時代・徳川家康の神格化',
    yearLabel: '1617年 創建 / 1636年 大規模造替',
    whcYear: 1999, whcNote: '「日光の社寺」の一部', emoji: '⛩',
    summary:
      '江戸幕府を開いた徳川家康をまつる神社で、1617年に日光に創建された。現在につながる華やかな社殿群は、三代将軍徳川家光による1636年の大規模な造替で整えられた。彫刻や彩色、金具などに多くの職人の技が集まり、陽明門などの装飾は幕府の権威を表すものでもあった。家康を神としてまつることは、徳川の支配を宗教的にも支える意味をもった。日光では神社と寺院が近接し、近代以前に神仏の信仰が重なっていた歴史も読み取れる。山の斜面に広がる社殿と参道を上空から見れば、平地の城とは異なる権威の見せ方を考えられる。東京の増上寺や江戸城跡と結び付けると、徳川家の政治と信仰の広がりが見えてくる。',
    quiz: {
      statement: '日光東照宮にまつられているのは、江戸幕府を開いた徳川家康である。',
      answer: true,
      explain: '家康をまつるため1617年に創建されました。豪華な社殿群には、三代将軍家光による造替の歴史も重なっています。',
    },
  },
  {
    // 出典: https://www.kotoku-in.jp/characteristic.html
    sources: ['https://www.kotoku-in.jp/characteristic.html'],
    id: 'kamakura-daibutsu',
    name: '鎌倉大仏（高徳院）', nameEn: 'Great Buddha of Kamakura',
    lat: 35.3167, lng: 139.5362, elevationM: 15,
    region: 'japan', era: 'medieval',
    country: '日本（神奈川県鎌倉市）', civilization: '鎌倉時代・仏教と鋳造技術',
    yearLabel: '1252年 銅造大仏の造立開始と伝わる',
    whcYear: null, emoji: '🛕',
    summary:
      '高徳院にある銅造の阿弥陀如来坐像で、鎌倉大仏として親しまれている。史料には1252年に銅造像の造立が始まったと記されるが、発願者や完成時期などには不明な点も多い。現在は屋外に座しているものの、当初から露天の像だったわけではなく、かつては大仏殿があった。建物が失われた後も仏像が残り、鎌倉時代の信仰と高度な鋳造技術を伝えている。奈良の東大寺の大仏が盧舎那仏であるのに対し、こちらは阿弥陀仏で、同じ「大仏」でもまつる仏は異なる。空から像の周囲の谷や山、海との位置関係を見れば、鎌倉の限られた平地に寺や町が築かれたことを実感できる。分かっていることと未解明なことを分けて読む練習にもなる。',
    quiz: {
      statement: '鎌倉大仏は、造られた当初から大仏殿のない屋外に安置されていた。',
      answer: false,
      explain: 'かつては大仏殿の中にありました。建物が失われた後に露座となったため、現在の姿から当初の姿を決めつけることはできません。',
    },
  },
  {
    // 出典: https://whc.unesco.org/en/list/776/
    sources: ['https://whc.unesco.org/en/list/776/'],
    id: 'itsukushima-shrine',
    name: '厳島神社', nameEn: 'Itsukushima Shrine',
    lat: 34.2959, lng: 132.3196, elevationM: 2,
    region: 'japan', era: 'medieval',
    country: '日本（広島県廿日市市）', civilization: '平安時代末期・平氏と海の信仰',
    yearLabel: '12世紀 平清盛の援助で社殿整備',
    whcYear: 1996, emoji: '⛩',
    summary:
      '瀬戸内海の宮島にある神社で、12世紀に平清盛の援助を受け、海辺に広がる大規模な社殿が整えられた。島の山々や海と建築が一体になった景観に特徴があり、潮が満ちると社殿や回廊が海上に浮かぶように見える。清盛の時代には瀬戸内海の航路や宋との交易が重要性を増しており、海の交通と権力、信仰を結び付けて考えられる場所である。現在の建物には災害後の再建も含まれ、景観は長い保護の歴史に支えられている。上空から社殿、大鳥居、背後の山の位置を見比べれば、建築だけを切り離して見ることでは分からない価値に気付ける。自然を背景に場所全体を理解するという世界遺産の見方も学べる。',
    quiz: {
      statement: '厳島神社の価値には、社殿だけでなく海や背後の山と調和した景観も含まれる。',
      answer: true,
      explain: '海辺の建築と周囲の自然が一体になった景観が特徴です。上空から見ることで、それぞれの位置関係を確かめられます。',
    },
  },
];
